<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="success"
        size="mini"
        @click="select()"
        >刷新</el-button
      >
      <el-button
        type="success"
        size="mini"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="width: 44px">用户</label>
        <el-input
          v-model="uid"
          placeholder="请输入用户uid"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <!-- <div class="item_warp">
        <label style="width: 44px">类目</label>
        <el-select v-model="subject" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option
            v-for="item in options"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </div> -->
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 771px"
      size="mini"
    >
      <el-table-column prop="memberUid" label="用户" width="100" />
      <el-table-column prop="fromTicket" label="原币种" width="100" />
      <el-table-column prop="toTicket" label="转换币种" width="100" />
      <el-table-column prop="fromAmount" label="原金额" width="100" />
      <el-table-column prop="toAmount" label="转换金额" width="100" />
      <el-table-column prop="pro" label="汇率" width="100" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      loading: false, // 表格加载
      dataTime: ["", ""],
      startDate: "",
      endDate: "",
      uid: "",
      options: [],
      subject: "",
      uid: "",
      symbol: "",
    };
  },
  created() {},
  mounted() {
    this.getList();
    // this.$api.operate
    //   .subjectList()
    //   .then((res) => {
    //     for (let key in res) {
    //       let obj = {}
    //       obj.key = key
    //       obj.value = res[key]
    //       console.log(obj)
    //       this.options.push(obj)

    //     }
    //   })
    //   .catch((err) => {
    //     this.$message.error(err || "服务器错误，请稍后重试");
    //   })
    //   .finally(() => {
    //     this.loading = false;
    //   });
  },
  methods: {
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    // 筛选
    select() {
      this.pageNum = 1; 
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid: this.uid,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .memberExchangeRecord(params)
        .then((res) => {
          this.tableData = res.records;
          this.loading = false;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// ::v-deep .el-table tr:first-child {
//   background-color: #edffe4 !important;
// }
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    // margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.head_search {
  display: flex;
  width: 100%;
  margin-bottom: 20px;

  .item_warp {
    display: flex;

    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }

    label {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
      font-weight: 400;
    }
  }
}
</style>
